module.exports = __webpack_public_path__ + "img/v-blue.2549e3ff.svg";